// extracted by mini-css-extract-plugin
export var banner = "_qq-0";
export var settingRow = "_qq-2";
export var titleIcon = "_qq-1";